import React from "react";

export function BackIcon() {
    return (
        <svg style={{ transform: "rotate(180deg)" }} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7 7.17143L1 13" stroke="#111111" strokeWidth="2"></path>
        </svg>
    );
}
